import { UtilityRunParameter } from "./utility-run-parameter";

export class UtilityRunRequest {
    constructor(parameters: UtilityRunParameter<any>[]) {
        this.parameters = parameters;
    }

    parameters: UtilityRunParameter<any>[];
}